const Textarea = ({
  icon,
  label,
  type,
  placeholder,
  rows,
  name,
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div>
      <div className="flex flex-row items-center text-[#3E0292] text-[12px]">
        <img src={icon} />
        <div className="mx-3 font-400">{label}</div>
      </div>
      <textarea
        disabled={disabled}
        onChange={onChange}
        value={value}
        className="rounded-lg border-[#D9D9D9] text-[#9E9E9E] text-[13px] w-[100%] mt-3 p-3 resize-none font-400"
        rows={rows}
        name={name}
        placeholder={placeholder}
      />
    </div>
  );
};

export default Textarea;
